$(document).ready(function () {

    $("form.RetOrderForm").die("submit").live("submit", function () {

        $form = $(this);

        $.ajax({
            type: "POST",
            url: $form.attr("action"),
            data: $form.serialize(),
            dataType: "json",
            beforeSend: function () {
                $('form.RetOrderForm input[type="submit"]').addClass('hide');
                $('form.RetOrderForm span.bekleyinizSpani').removeClass('hide');
            },
            success: function (dt) {
                $('form.RetOrderForm input[type="submit"]').removeClass('hide');
                $('form.RetOrderForm span.bekleyinizSpani').addClass('hide');

                if (dt.Sonuc === true) {
                    $("#AlertResult").removeClass("alert-error");
                    $form.hide();
                    $("#AlertResult").addClass("alert-success").show().find("span").html(dt.IslemSonucAciklama);
                    $(".RetTypeHome").css("display", "inline-block");
                }
                else {
                    $("#AlertResult").addClass("alert-danger");
                    $("#AlertResult").addClass("alert-error").show().find("span").html(dt.IslemSonucAciklama);
                }
                $('html, body').animate({
                    scrollTop: 0
                }, 500);
            },
            error: function () {

                alert('Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!');
            }
        });
        return false;
    });

    $(".MoneyTransferForm #Amount").live('keyup', function (e) {

        var moneytansferAmount = $(this).val();

        var replacedVal = moneytansferAmount.replace(",", "");
        replacedVal = replacedVal.replace(",", "");
        replacedVal = replacedVal.replace(".", "");
        replacedVal = replacedVal.replace(".", "");

        if (!isNumeric(replacedVal)) {
            $(".MoneyTransferForm #Amount").val("");
        }
        else {


            var newVal = moneytansferAmount.replace(",", ".");
            newVal = newVal.replace(",", ".");

            $(".MoneyTransferForm #Amount").val(newVal);

        }

    });

    $("form.MoneyTransferForm").live("submit", function () {

        $form = $("form.MoneyTransferForm");

        $.ajax({
            type: "POST",
            url: $form.attr("action"),
            data: $form.serialize(),
            dataType: 'json',
            success: function (dta) {

                if (dta.Sonuc == true) {

                    $("#MoneyTransferResult").html(dta.IslemSonucAciklama);

                    $form.find("table").hide();

                    $("#MoneyTransferResult").removeClass("alert-error");
                    $("#MoneyTransferResult").addClass("alert alert-success").show();

                }
                else {

                    $("#MoneyTransferResult").html(dta.IslemSonucAciklama);
                    $("#MoneyTransferResult").addClass("alert alert-error").show();
                }


            },
            error: function () {

                alert('Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!');
            }

        });

        return false;
    });

    $("form.WesternUnionMoneyTransferForm").live("submit", function () {

        $form = $("form.WesternUnionMoneyTransferForm");

        $.ajax({
            type: "POST",
            url: $form.attr("action"),
            data: $form.serialize(),
            dataType: 'json',
            success: function (dta) {

                if (dta.Sonuc == true) {

                    $("#WUMoneyTransferResult").html(dta.IslemSonucAciklama);

                    $("#WUMoneyTransferResult").removeClass("alert-error");

                    $("#WUMoneyTransferResult").addClass("alert alert-success").show();
                }
                else {

                    $("#WUMoneyTransferResult").html(dta.IslemSonucAciklama);

                    $("#WUMoneyTransferResult").addClass("alert alert-error").show();
                }
            },
            error: function () {

                alert('Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!');
            }
        });

        return false;
    });

    $('.CancelRow select.RetType').live("change", function () {
        var CName = $("#CName").val();

        //alert("CName: " + CName);

        if (CName == "Home") {
            url = "/Home/RetOrderType";
        } else {
            url = "/Orders/RetOrderType";
        }


        var value = $(this).val();

        $selectedRetTypeThis = $(this);

        var returnProduct = $selectedRetTypeThis.parents(".CancelRow").hasClass("returnProduct");

        if (value == "0") {
            $selectedRetTypeThis.parents(".CancelRow").find(".RetReason").css("display", "none");
        }
        else if (value == "1" || value == "2" || value == "6") {
            $.ajax({
                type: "POST",
                url: url,
                data: "RetType=" + value,
                dataType: 'json',
                success: function (dta) {

                    dta.JsonRs = JSON.parse(dta.JsonRs);

                    $selectedRetTypeThis.parents(".CancelRow").find(".RetReason").html("");

                    for (var i = 0; i < dta.JsonRs.length; i++) {
                        $selectedRetTypeThis.parents(".CancelRow").find(".RetReason").append(new Option(dta.JsonRs[i].Text, dta.JsonRs[i].Value));
                    }

                    $selectedRetTypeThis.parents(".CancelRow").find(".RetReason").css("display", "block");

                },
                error: function () {

                    alert('Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!');
                }
            });
        }
        else if (value == "-1") {
            $selectedRetTypeThis.parents(".CancelRow").find(".RetReason").css("display", "none");
        }

        var slc = $(this);

        var oid = slc.attr("dataid");


        var ind = slc.attr("dataind");


        var kacitem = parseInt($(".CancelRow select.RetType").length);


        if (kacitem <= 0) return;

        var itemsay = 0;

        var iaTutar = parseFloat(calcIadeTutari());

        //alert("iaTutar: " + iaTutar);

        var siptutar = parseFloat($("#TotalRetOrderAmount").attr("dataAmount").replace(",", "."));

        //alert("siptutar: " + siptutar);

        if (value === "2" || value === "4" || value === "6") {

            itemsay = parseInt(itemsay) + 1;

            //iaTutar += parseFloat($('#urunAmount' + $(this).attr("dataid")).val().replace(",", "."));

            $selectedRetTypeThis.parents(".CancelRow").addClass("returnProduct");

        } else if (iaTutar > 0 && returnProduct == true) {

            //iaTutar -= parseFloat($('#urunAmount' + $(this).attr("dataid")).val().replace(",", "."));

            $selectedRetTypeThis.parents(".CancelRow").removeClass("returnProduct");

        }

        //if (kacitem === itemsay) {
        //    iaTutar = siptutar;
        //}

        if (itemsay > 0 && iaTutar > 0) {
            $(".iadedivi").removeClass("hide");
        }
        else if (itemsay == 0 && iaTutar == 0) {
            $(".iadedivi").addClass("hide");
        }
        if (slc.val() === "1" || slc.val() === "3") { //değişim yapmak istiyorum
            $(".CancelRow select[name=\"RetItem[" + ind + "].DegisimStoklar\"]").removeClass("hide");
        }
        else {
            $(".CancelRow select[name=\"RetItem[" + ind + "].DegisimStoklar\"]").addClass("hide");
        }

        $("#RetTotalAmount").html((iaTutar).toFixed(2) + " TL");

        $("#RetTotalAmountVal").val(iaTutar);

        $("#OrderAmountAfterRet").html((siptutar - iaTutar).toFixed(2) + " TL");
    });

    function calcIadeTutari() {

        var totalRetVal = 0;

        $(".CancelItems .RetOrderItem.CancelRow").each(function () {

            var retTypeVal = $(this).find("select.RetType").val();

            if (retTypeVal == 2 || retTypeVal == 6) {

                totalRetVal += parseFloat($(this).find("input[type='hidden']").val().replace(",", "."));

                //alert("result: " + totalRetVal)
            }
        });

        return totalRetVal;
    }

    $('.changePassCancel').click(function () {
        $('.ChangePassForm input').val('');

    });

    $("a.MyOldOrdersBtn").click(function () {

        $(".MyOldOrders").show();
    });

    $(".deliveryeditmode a").live("click", function () {
        $(".ConfirmDeliveryEdits").show();
        $(".OrderDeliveryAdresEdit").show();
        $(".deliveryeditmode").hide();
        $(".OrderDeliveryAdres").hide();
    });

    //$(".billingeditmode a").live("click", function () {
    //    $(".ConfirmBillingEdits").show();
    //    $(".OrderBillingAdresEdit").show();
    //    $(".billingeditmode").hide();
    //    $(".OrderBillingAdres").hide();
    //});

    $(".ConfirmDeliveryEdits a.cancel").live("click", function () {

        $(".ConfirmDeliveryEdits").hide();
        $(".OrderDeliveryAdresEdit").hide();
        $(".deliveryeditmode").show();
        $(".OrderDeliveryAdres").show();
    });

    //$(".ConfirmBillingEdits a.cancel").live("click", function () {
    //    $(".ConfirmBillingEdits").hide();
    //    $(".OrderBillingAdresEdit").hide();
    //    $(".billingeditmode").show();
    //    $(".OrderBillingAdres").show();
    //});

    $(".ConfirmDeliveryEdits a.confirm").live("click", function () {
        var CName = $("#CName").val();
        if (CName == "Home") {
            url = "/Home/ChangeDeliveryAddressInOrder"
        } else {
            url = "/Orders/ChangeDeliveryAddressInOrder"
        }
        var params = "oID=" + $("#oID").val() + "&DeliveryAdressDetail=" + $("#DeliveryAdressDetail").val() + "&EditdCity=" + $("#EditdCity").val() + "&EditdTown=" + $("#EditdTown").val() + "&DeliveryAdressGSM=" + $("#DeliveryAdressGSM").val() + "&DeliveryPostalCodeHidden=" + $("#DeliveryPostalCodeHidden").val();
        console.log(params);
        $.ajax({
            type: "GET",
            url: url,
            data: params,
            cache: false,
            async: false,
            success: function (data) {

                if (data != null && data.Status == true) {

                    $(".OrderDeliveryAdres").html(data.ResultDescription);

                    $(".ConfirmDeliveryEdits").hide();
                    $(".OrderDeliveryAdresEdit").hide();
                    $(".deliveryeditmode").show();
                    $(".OrderDeliveryAdres").show();
                    window.location.reload();

                }
                else if (data != null && data.Status == false) {

                    alert(data.ResultDescription);
                }
                else {

                    alert('Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz....!');
                }

            },
            error: function () {

                alert('Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!');
            }

        });
    });

    //$(".ConfirmBillingEdits a.confirm").live("click", function () {

    //    var params = "oID=" + $("#oID").val() + "&BillingAdressDetail=" + $("#BillingAdressDetail").val() + "&EditbCity=" + $("#EditbCity").val() + "&EditbTown=" + $("#EditbTown").val() + "&BillingAdressGSM=" + $("#BillingAdressGSM").val() + "&BillingPostalCodeHidden=" + $("#BillingPostalCodeHidden").val();
    //    $.ajax({
    //        type: "GET",
    //        url: "/Orders/ChangeBillingAddressInOrder",
    //        data: params,
    //        cache: false,
    //        async: false,
    //        success: function (data) {
    //            if (data != null && data.Status == true) {
    //                $(".OrderBillingAdres").html(data.ResultDescription);
    //                $(".ConfirmBillingEdits").hide();
    //                $(".OrderBillingAdresEdit").hide();
    //                $(".billingeditmode").show();
    //                $(".OrderBillingAdres").show();
    //                window.location.reload();
    //            }
    //            else if (data != null && data.Status == false) {

    //                alert(data.ResultDescription);
    //            }
    //            else {

    //                alert('Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz....!');
    //            }
    //        },
    //        error: function () {
    //            alert('Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!');
    //        }

    //    });
    //});

    $(".ddl_dcity").live("change", function () {
        var CName = $("#CName").val();
        if (CName == "Home") {
            url = "/Home/GetTowns"
        } else {
            url = "/Orders/GetTowns"
        }
        var seciliSehirOID = $(this).val();
        $(".ajaxilce").show();
        $.ajax({
            type: 'get',
            url: url,
            data: 'cityid=' + seciliSehirOID,
            dataType: 'json',
            success: function (dt) {

                var icerik = "";
                $('#EditdTown option').remove();

                $('#EditdTown')
                    .append($("<option></option>")
                        .attr("value", "0")
                        .text("Lütfen Seçin"));

                for (var i = 0; i < dt.length; i++) {
                    $('#EditdTown').append(new Option(dt[i].Name, dt[i].ID));

                }

                $(".ajaxilce").hide();
            }
        });


    });

    //$(".ddl_bcity").live("change", function () {

    //    var seciliSehirOID = $(this).val();
    //    $(".ajaxilce").show();

    //    $.ajax({
    //        type: 'get',
    //        url: '/Orders/GetTowns',
    //        data: 'cityid=' + seciliSehirOID,
    //        dataType: 'json',
    //        success: function (dt) {

    //            var icerik = "";
    //            $('#EditbTown option').remove();

    //            $('#EditbTown')
    //                .append($("<option></option>")
    //                    .attr("value", "0")
    //                    .text("Lütfen Seçin"));

    //            for (var i = 0; i < dt.length; i++) {
    //                $('#EditbTown').append(new Option(dt[i].Name, dt[i].ID));

    //            }

    //            $(".ajaxilce").hide();


    //        }
    //    });


    //});

    if ($(".OrderDeliveryAdresEdit  #DeliveryAdressGSM").length > 0) {
        var CountryCode = "TR";
        if (CountryCode.length > 0 && CountryCode == "TR") { //Sadece Türkiye için
            $(".OrderDeliveryAdresEdit #DeliveryAdressGSM").mask("999 999 99 99");
        }
    }

    $("a.CargoDetailModal").live("click", function (event) {

        event.preventDefault();

        var x = $(this);
        var OrderModal = $("div#long");
        var ModalTitle = $("h3.modal-title", OrderModal);
        var ModalContent = $("div.modal-body", OrderModal);

        var CurrentTitle = $(x).children("td:first").html();

        $(ModalTitle).html($("h3.ModalTitle").text());

        $.get(x.attr("data-trackFile"), function (data) {
            $(ModalContent).html(data);
        });
    });

});
function maxLengthCheck(object) {
    if (object.value.length > object.maxLength)
        object.value = object.value.slice(0, object.maxLength)
}

function isNumeric(evt) {
    var theEvent = evt || window.event;
    var key = theEvent.keyCode || theEvent.which;
    key = String.fromCharCode(key);
    var regex = /[0-9]|\./;
    if (!regex.test(key)) {
        theEvent.returnValue = false;
        if (theEvent.preventDefault) theEvent.preventDefault();
    }
}
